import * as React from 'react'

import { TypographyProps } from '@bestyled/system'
import { filterTextProps } from '../util/filterTextProps'

export interface DefaultTextStyleProps extends TypographyProps {
  style?: any
  className?: any
}

const DefaultTextContext = React.createContext<Partial<DefaultTextStyleProps>>(
  null!
)

export const useDefaultTextStyles = () => React.useContext(DefaultTextContext)

export const DefaultTextProvider: React.FC<Partial<DefaultTextStyleProps>> = (
  props
) => {
  return (
    <DefaultTextContext.Provider value={{ ...filterTextProps(props) }}>
      {props.children}
    </DefaultTextContext.Provider>
  )
}

export const DefaultTextStyle: React.FC<DefaultTextStyleProps> = (props) => {
  const prevDefaults = useDefaultTextStyles()

  if (!prevDefaults) {
    throw new Error(
      '<DefaultTextStyle> used without containing <DefaultTextProvider>'
    )
  }

  const defaults = { ...prevDefaults, ...filterTextProps(props) }

  return (
    <DefaultTextContext.Provider value={defaults}>
      {props.children}
    </DefaultTextContext.Provider>
  )
}
